import { useEffect } from "react";
import { Button, Flex } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { Fragment } from "react";
import VerifyHeader from "src/components/pages/Summary/VerifyEntries/VerifyHeader";
import AuthLogbookModal from "src/components/shared/_Modals/AuthLogbookModal/AuthLogbookModal";
import Section from "src/components/shared/EntriesGenerator/Section/Section/Section";
import CheckListsModal from "src/generator/_Modals/CheckListsModal/CheckListsModal";
import { useShowContent } from "src/generator/hooks/useShowContent";
import { PageContainer } from "src/styled";

import LandscapeSection from "../../../components/shared/EntriesGenerator/Section/LandscapeSection/LandscapeSection";
import { MEDLBID } from "../../../utils";
import VerificationSignature from "./VerificationSignature/VerificationSignature";
import { useVerifyEntries } from "./VerifyEntries.hooks";
import { useIsDev } from "src/hooks/useIsDev";
import { GeneratorV2 } from "src/generatorV2";

const VerifyEntries = () => {
  const isDev = useIsDev();
  const { shouldHideElement } = useShowContent();
  const {
    lbEntry,
    sections,
    unauthorized,
    lbid,
    idata,
    fetchRestricted,
    secdata,
    ...headerProps
  } = useVerifyEntries();

  useEffect(() => {
    isDev && sections.length > 0 && console.log({ sections });
  }, [sections]);

  const [opened, { open, close }] = useDisclosure(false);
  return (
    <PageContainer>
      <VerifyHeader
        lbid={lbid}
        unauthorized={unauthorized}
        {...headerProps}
        isMedLog={lbid === MEDLBID}
      />
      {unauthorized ? (
        <>
          <Flex justify="center">
            <Button onClick={open}>Authorize</Button>
          </Flex>
          <AuthLogbookModal
            opened={opened}
            close={close}
            lbid={lbid ?? ""}
            onSuccess={fetchRestricted}
          />
        </>
      ) : null}

      {unauthorized ? null : lbEntry?.generator === "v2" ? (
        <GeneratorV2
          logbookDef={lbEntry}
          entryInfo={{ ...headerProps }}
          options={{ readonly: true }}
        />
      ) : (
        sections?.length > 0 &&
        sections.map((s, i) => {
          if (shouldHideElement(s)) return null;

          return s.subSections ? (
            <Fragment key={`fr-${i}`}>
              {s.subSections.map((sub, subI) => {
                if (shouldHideElement(sub as any)) return null;
                return <LandscapeSection section={sub} key={`sub-${subI}`} />;
              })}
            </Fragment>
          ) : (
            <Section key={i} sIndex={i} section={s} />
          );
        })
      )}
      <Flex gap={10}>
        {idata && (
          <VerificationSignature idata={idata} title="Verified Signature" />
        )}
        {secdata && (
          <VerificationSignature idata={secdata} title="Co Signed Signature" />
        )}
      </Flex>

      <CheckListsModal type="summary" />
    </PageContainer>
  );
};

export default VerifyEntries;
